/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../../configs/const';
import * as depositWithdrawalService from '../../services/depositWithdrawalService';
import * as accountServices from '../../services/accountService';
import { PAYINOUTMANUALCOUNTRY, PAYINOUTMANUALEMAILSUPPORT } from '../../configs/apkFileName';
import { OPERATOR_ID } from '../../configs/const';
class Depositpopuphebebook extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            countrySelected: 'GE',
            userId:'',
            amount:0,
            emailId:'',
            mobileNumber:'',
            balance: 0,
            operatorId: '',
            accountHolderName: "",
            accountNumber: "",
            iFSCCode: "",
            paymentMode: "Bank",
            upiType: "Gpay",
            walletName: "",
            walletNumber: "",
        };
    }
    componentDidMount() {
        this.getBalance()
    }
    getBalance(){
        
        accountServices.getProfileData(this.state.uid).then((res) => {
            
            let profData = res
            let userData = profData
            profData = JSON.stringify(profData)
            localStorage.setItem("profData", profData)

            // let userData = localStorage.getItem('profData')
            if(!!profData){
            let bal = parseFloat(userData.availableBalance);
            if(!!userData.exposure){
                bal = bal + parseFloat(userData.exposure)
            }
            if(!!userData.upLineBalance){
                bal = bal + parseFloat(userData.upLineBalance)
            }
            this.setState({userId: userData.username, emailId: userData.email, mobileNumber: userData.mobile, balance: bal.toFixed(2), operatorId: userData.operatorId})
            }
        });
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }  

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }
    onDepositClick(){
        const self = this
        if(this.state.amount < 500){
            this.props.notify("Minimum deposit amount is 500", "warning")
            return false
        }
        let body={
            "operatorId" : this.state.operatorId,
            "username" : this.state.userId,
            "amount" : this.state.amount,
        }
        // "email" : this.state.emailId,
        // "mobile" : this.state.mobileNumber,
        // "returnUrl": window.origin + "/transactionStatus/" orderId
        depositWithdrawalService.depositOrder(body).then((res) => {
            if (!!res) {
                if(!!res.orderId){
                    window.location.href = res.url
                } else {
                    self.props.notify(`${res.exception.code} ${res.exception.message}`, "error")
                    self.props.hidePopup()
                }
            }
        }).catch(error => {
            self.props.notify(error, "error")
        });
        
    }
    validateWithdrawalForm(){
        let returnval = true;
        if(this.state.paymentMode === "Bank"){
            returnval = !!this.state.accountHolderName && this.state.accountHolderName.length > 1 && !!this.state.accountNumber && this.state.accountNumber.length > 4 && !!this.state.iFSCCode && this.state.iFSCCode.length > 9 && !!this.state.amount && parseFloat(this.state.amount) >= 500 && parseFloat(this.state.amount) <= parseFloat(this.state.balance) ? false : true;
        } else {
            returnval = !!this.state.upiType && !!this.state.walletName && this.state.walletName.length > 1 && !!this.state.walletNumber && this.state.walletNumber.length > 9 && !!this.state.amount && parseFloat(this.state.amount) >= 500 && parseFloat(this.state.amount) <= parseFloat(this.state.balance) ? false : true;
        }
        return returnval
    }    
    onWithdrawalClick(){
        const self = this
        let body={
            "operatorId" : this.state.operatorId,
            "username" : this.state.userId,
            "amount" : this.state.amount,
            "paymentMode" : this.state.paymentMode,
            "accountName" : this.state.paymentMode === "Bank" ? this.state.accountHolderName : this.state.walletName,
            "accountNumber" : this.state.paymentMode === "Bank" ? this.state.accountNumber : this.state.walletNumber,
            "routingInformation" : this.state.paymentMode === "Bank" ? this.state.iFSCCode : this.state.upiType,
        }
        // "email" : this.state.emailId,
        // "mobile" : this.state.mobileNumber,
        document.getElementById("btnWithdraw").disabled = true;
        depositWithdrawalService.withdrawalOrder(body).then((res) => {
            document.getElementById("btnWithdraw").disabled = false
            if (!!res) {
                if(!!res.withdrawId){
                    self.props.notify(`We have recevied your withdraw request. withdrawId: ${res.withdrawId}. For any support, contact our chat executive or whatsapp.`, "success")
                    self.setState({
                        // userId:'',
                        // emailId:'',
                        // mobileNumber:'',
                        // operatorId: '',
                        bankName: "",
                        accountHolderName: "",
                        accountNumber: "",
                        iFSCCode: "",
                        // balance: parseFloat(self.state.balance) - self.state.amount,
                        amount: 0,
                        upiType: "Gpay",
                        walletName: "",
                        walletNumber: "",
                    },()=>{
                        self.getBalance()
                        // window.location.reload()
                    })
                } else {
                    self.props.notify(`${res.exception.code} ${res.exception.message}`, "error")
                }
            } 
        }).catch(error => {
            document.getElementById("btnWithdraw").disabled = false
            self.props.notify(error, "error")
        });
    }
    render() {       
        
        return (
            <>
                <div id="marketbetspopup" className="modal fade show sign-up-form depositpopup hebebox" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className={this.state.selectedPage === "paymentselection" ? "modal-dialog  modal-dialog-scrollable modal-sm" : "modal-dialog  modal-dialog-scrollable modal-sm"} >
                        <div className="modal-content hebebox">
                            <div className="modal-header hebebox">
                                <button onClick={() => { this.props.hidePopup() }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            {/* AMOUNT ADD WALLET DEPOSIT POPUP */}      
                                                 
                            <div className="modal-body" id='content'>
                                <div className='mb-3'>
                                <div className='country-title'>Choose Country</div>
                                </div>
                                <div className='country-select d-none'>
                                    <div className='country-box-main mb-2'>
                                        <div><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/georgia-flag.png"}/> Georgia</div>
                                    </div>
                                    <div className='country-box-main mb-2'>
                                        <div><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/europe-flag.png"}/> Europe</div>
                                    </div>
                                    <div className='country-box-main mb-3'>
                                        <div><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/usa-flag.png"}/> USA</div>
                                    </div>
                                </div>
                                <div className='' >
                                    <div className="btn-group w-100 deposit-withdrowal-btn-box" role="group" aria-label="Basic example">
                                        <button type="button" className={this.state.countrySelected === 'GE' ? "btn btn-deposit active w-50 border-right1 hebe-text-left" : "btn btn-deposit w-50 border-right1 hebe-text-left"} onClick={()=>{this.setState({countrySelected: 'GE'})}}><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/georgia-flag.png"}/> Georgia</button>
                                        <button type="button" className={this.state.countrySelected === 'EU' ? "btn btn-deposit active w-50 border-right1 hebe-text-left" : "btn btn-deposit w-50 border-right1 hebe-text-left"} onClick={()=>{this.setState({countrySelected: 'EU'})}}><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/europe-flag.png"}/> Europe</button>
                                        {OPERATOR_ID ==='RDR' && <button type="button" className={this.state.countrySelected === 'US' ? "btn btn-deposit active w-50 hebe-text-left" : "btn btn-deposit w-50 hebe-text-left"} onClick={()=>{this.setState({countrySelected: 'US'})}}><img alt='flag' className='country-flag-icon' src={BASE_IMAGE_PATH + "/casino/banner/loginimages/usa-flag.png"}/> USA</button>}
                                    </div>
                                    {/* <div className='deposit-withdrowal-btn-box'>dsdsd</div> */}
                                    {/* <h5 className="modal-title mt-2 text-black text-center" id="myModalLabel">MAKE A DEPOSIT</h5>  */}
                                    <div className='payment-methods mt-2 hebe-flex-direction-col'>
                                        {this.state.countrySelected === 'GE' &&
                                            <div className='depositboxview'>                                                                  
                                                {/* middle part start */}
                                                <div className='payment-methods__detail-form payment-methods__scrollable paymentpadding'>
                                                    <div className='payment-methods__form-head'>
                                                        <div className='form-group'>
                                                            <div className='manual-icon d-flex mb-3'>
                                                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/deposit-icon.png"} alt="Deposit" title='Deposit'></img>
                                                                <div className='form-title d-inline ml-2'>For Deposit and Withdrawal  <br></br>                                                     
                                                                {PAYINOUTMANUALCOUNTRY['GE'].map(itm => {
                                                                        return(
                                                                            <a className='link-over-white depomodel-hebe-num-gap' href={`tel:${itm.number}`} target="_blank" rel="noreferrer"><i className='fa fa-phone-square mr-1'></i>{itm.label}</a>
                                                                        )
                                                                    }
                                                                    )}                                                     
                                                                </div>                                                      
                                                            </div> 
                                                            <div className='manual-icon mb-3 mt-2'>
                                                                <p className='hebe-blacktext'>Available Payment Mode</p>
                                                                <div className='hebe-blackcolor'>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>Bank</p>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>Unipay</p>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>Epay by Bank of Georgia</p>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>TBC Pay</p>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>Crypto</p>
                                                                    <p><i className='fa fa-check-square-o pr-1'></i>Local Cash Pick-Up: TBILISI ALL OVER TBILISI CITY . BATUMI CITY</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                                                                               
                                                    </div>
                                                </div>
                                                {/* END middle part */}
                                            </div>
                                        }
                                        {this.state.countrySelected === 'EU' && 
                                           <div className='depositboxview'>                                                                  
                                           {/* middle part start */}
                                           <div className='payment-methods__detail-form payment-methods__scrollable paymentpadding'>
                                               <div className='payment-methods__form-head'>
                                                   <div className='form-group'>
                                                       <div className='manual-icon d-flex mb-3'>
                                                           <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/deposit-icon.png"} alt="Deposit" title='Deposit'></img>
                                                           <div className='form-title d-inline ml-2'>For Deposit and Withdrawal  <br></br>                                                     
                                                           {PAYINOUTMANUALCOUNTRY['EU'].map(itm => {
                                                                   return(
                                                                       <a className='link-over-white depomodel-hebe-num-gap' href={`tel:${itm.number}`} target="_blank" rel="noreferrer"><i className='fa fa-phone-square mr-1'></i>{itm.label}</a>
                                                                   )
                                                               }
                                                               )}                                                     
                                                           </div>                                                      
                                                       </div> 
                                                       <div className='manual-icon mb-3 mt-2'>
                                                           <p className='hebe-blacktext'>Available Payment Mode</p>
                                                           <div className='hebe-blackcolor'>
                                                               <p><i className='fa fa-check-square-o pr-1'></i>Banks N D</p>
                                                               <p><i className='fa fa-check-square-o pr-1'></i>SaxoBank Wallet</p></div>
                                                       </div>

                                                   </div>
                                                                                                          
                                               </div>
                                           </div>
                                           {/* END middle part */}
                                       </div>
                                        }
                                        {this.state.countrySelected === 'US' && 
                                            <div className='depositboxview'>
                                                 <div className='payment-methods__detail-form payment-methods__scrollable paymentpadding'>
                                                    <div className='payment-methods__form-head'>
                                                        <div className='form-group'>
                                                            <div className='manual-icon d-flex mb-3'>
                                                                <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/deposit-icon.png"} alt="Deposit" title='Deposit'></img>
                                                                <div className='form-title d-inline ml-2'>For Deposit and Withdrawal  <br></br>                                                     
                                                                {PAYINOUTMANUALCOUNTRY['US'].map(itm => {
                                                                        return(
                                                                            <a className='link-over-white depomodel-hebe-num-gap' href={`tel:${itm.number}`} target="_blank" rel="noreferrer"><i className='fa fa-phone-square mr-1'></i>{itm.label}</a>
                                                                        )
                                                                    }
                                                                    )}                                                     
                                                                </div>                                                      
                                                            </div> 
                                                            <div className='manual-icon mb-3 mt-2'>
                                                                <p className='hebe-blacktext'>Available Payment Mode</p>
                                                                <div className='hebe-blackcolor'>
                                                                    <div className='usacontent'>
                                                                        <div className='usacontent-inner'>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Banks</p>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Zelles</p>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Cashapp</p>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Venmo</p>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Fedex</p>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Crypto</p>
                                                                        </div>
                                                                        <div className='usacontent-inner'>
                                                                            <p><i className='fa fa-check-square-o pr-1'></i>Local Cash Pick-up</p>
                                                                            <p><i className='fa fa-caret-right pr-1 ml-3'></i>North Carolina</p>
                                                                            <p><i className='fa fa-caret-right pr-1 ml-3'></i>Mississippi</p>
                                                                            <p><i className='fa fa-caret-right pr-1 ml-3'></i>Alabama</p>
                                                                            <p><i className='fa fa-caret-right pr-1 ml-3'></i>New Jersey</p>
                                                                            <p><i className='fa fa-caret-right pr-1 ml-3'></i>Georgia</p>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    
                                                                    
                                                                    </div>
                                                            </div>

                                                        </div>
                                                                                                                
                                                    </div>
                                                </div>
                                            </div>
                                        } 

                                        <div className='d-flex d-flex-mobile-view support-border'>
                                            <div className='payment-methods__detail-form payment-methods__scrollable'>
                                                <div className='payment-methods__form-head'>
                                                    <div className='form-group'>
                                                        <div className='manual-icon supportmanual-icon d-flex mb-1'>
                                                            <img src={BASE_IMAGE_PATH + "/casino/banner/loginimages/support-icon.png"} alt="Support" title='Support'></img>
                                                            <div className='form-title d-inline ml-2'>For Email's Support <br></br>                                                     
                                                            {PAYINOUTMANUALEMAILSUPPORT.map(itm => {
                                                                    return(
                                                                        <a className='link-over-white d-block email-support-fontsize ' href={`mailto:${itm.email}`} target="_blank" rel="noreferrer"><i className='fa fa-envelope-open mr-1'></i>${itm.label}</a>
                                                                        )
                                                                }
                                                                )}                                                     
                                                            </div>                                                      
                                                        </div>                                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                            
                                    </div>
                                    
                                </div>
                            </div> 
                            
                            {/*END AMOUNT ADD WALLET DEPOSIT POPUP */}
                                                           
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Depositpopuphebebook);
